import { SortDirection } from '@common/types';
import { compareAsString } from '@common/utils/helpers/comparators';

export const getSortDirection = (activeDirection: SortDirection) => {
  return compareAsString(activeDirection, SortDirection.Desc) ? SortDirection.Asc : SortDirection.Desc;
};

